import { render, staticRenderFns } from "./RemoveScholarshipModal.vue?vue&type=template&id=38c18e49&scoped=true&"
import script from "./RemoveScholarshipModal.vue?vue&type=script&lang=js&"
export * from "./RemoveScholarshipModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c18e49",
  null
  
)

export default component.exports